import { FaCheck, FaTimes } from "react-icons/fa";

const VouchStats = ({ node }) => {
  return (
    <div className="p-6">
      <table className="min-w-full divide-y divide-gray-200">
        <thead>
          <tr>
            <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Total Vouchers
            </th>
            <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Not Expired
            </th>
            <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Not Expired True Friends
            </th>
            <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Valid Vouches in Set
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          <tr>
            <td className="px-6 py-4 whitespace-nowrap font-bold">
              {node.all_vouchers.length}
            </td>
            <td className="px-6 py-4 whitespace-nowrap font-bold">
              {node.all_vouchers_not_expired.length}
            </td>
            <td className="px-6 py-4 whitespace-nowrap font-bold">
              {node.true_friends.length}
            </td>
            <td className="px-6 py-4 whitespace-nowrap flex items-center">
              {node.valid_vouches_in_set[0] ? (
                <FaCheck className="text-green-500 ml-2" />
              ) : (
                <FaTimes className="text-red-500 ml-2" />
              )}
              <span className="font-bold ml-2">
                {node.valid_vouches_in_set[1]}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default VouchStats;
